import React, {createRef, useEffect, useState} from "react";
import {useSelector} from "react-redux"
import OptionNavigator from "../organisms/OptionNavigator";
import OptionSelector from "../organisms/OptionSelector";
import useOptionController from "./useOptionController";
import OptionMiddleLayer from "../organisms/OptionMiddleLayer";


const OptionController = () => {
  const childNavigationData = useSelector(state => state.optionWindow.childNavigationData);
  const dataSub = useSelector(state => state.optionWindow.dataSub);
  const dataDepth = useSelector(state => state.optionWindow.dataDepth);
  const isGnb = useSelector(state => state.optionWindow.isGnb);

  const optionRef = createRef();

  const { slideToMainHandler, slideToSubHandler } = useOptionController();

  const [optionOpened, setOptionOpened] = useState(false);

  useEffect(() => {
    setOptionOpened(!isGnb);

    optionRef.current.addEventListener("wheel", (e) => {
      e.stopPropagation();
    },{ passive: false})
  },[isGnb]);


  return (
    <aside className={`option-wrap ${optionOpened ? "aside-open" : ""}`} data-depth={dataDepth} data-sub={dataSub} ref={optionRef}>
      <div className={"option-viewport"}>
        <div className={"option-slide"}>
          <OptionNavigator slideToSubHandler={slideToSubHandler} />
          <OptionMiddleLayer slideToSubHandler={slideToSubHandler} slideToMainHandler={slideToMainHandler}/>
          <OptionSelector childNavigationData={childNavigationData} slideToMainHandler={slideToMainHandler}/>
        </div>
      </div>
      <div className={`toggle-option ${!optionOpened && 'is-hiding'}`} onClick={() => setOptionOpened(current => !current)}>
        <span></span>
        <button type={"button"}></button>
      </div>
    </aside>
  )
}

export default OptionController;
